<template>    
    <div class="w-full flex flex-col justify-center">
        <span v-if="!$props.noInfo && $props.info" :class="$props.infoClasses">
            {{ $props.info.replaceAll('\\', '') }}
        </span>
        <h2 :class="$props.titleClasses">
            {{ $props.title.replaceAll('\\', '') }}
        </h2>
        <p :class="$props.abstractClasses" v-if="!$props.noAbstract && $props.abstract">
            {{ $props.abstract.replaceAll('\\', '') }}
        </p>        
    </div>
</template>

<script>
export default {
    props: {
        title: { type: String, required: true},
        titleClasses: { type: String, default: ''},
        
        info: { type: String, default: ''},
        infoClasses: { type: String, default: ''},
        noInfo: { type: Boolean, default: false },

        abstract: { type: String, default: ''},
        noAbstract: { type: Boolean, default: false },
        abstractClasses: { type: String, default: ''},
    }  
}
</script>